if (!customElements.get('creg-section-media-gallery')) {
  class CregSectionMediaGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.items = [...this.querySelectorAll('[data-creg-media-item]')];
      this.buttons = [...this.querySelectorAll('[data-creg-media-target]')];
      this.autoplay = this.dataset.autoplay === 'true';

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.activate(button.dataset.cregMediaTarget));
      });
    }

    activate(targetIndex) {
      this.items.forEach((item) => {
        const active = item.dataset.cregMediaItem === targetIndex;
        item.hidden = !active;
        item.classList.toggle('is-active', active);

        const video = item.querySelector('video');
        if (!video) return;
        if (!active) video.pause();
        if (active && this.autoplay) video.play().catch(() => {});
      });

      this.buttons.forEach((button) => {
        const active = button.dataset.cregMediaTarget === targetIndex;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('creg-section-media-gallery', CregSectionMediaGallery);
}
